<template>
  <div class="container-main">
    <div class="container-main-header-button">
      <v-btn depressed @click="back">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span>Выбор события</span>
    </div>
    <v-form ref="formFirst">
      <div class="container-block">
        <div>
          <v-autocomplete :items="events" outlined item-text="name" item-value="id" :rules="rules" clearable
            v-model="newsOrEventId" label="Выберите событие"></v-autocomplete>
        </div>
      </div>
    </v-form>
    <div class="container-block">
      <div class="container-block-title">Настройки баннера</div>
      <div class="d-flex" style="flex-direction: column; justify-content: center; gap: 20px;">
        <v-switch label="Отображать только на старых версиях" v-model="isVisibleInNewAppVersion" hide-details
          color="var(--app-green-1)"></v-switch>
        <v-switch label="Отображать на Android" v-model="isVisibleOnAndroid" hide-details
          color="var(--app-green-1)"></v-switch>
        <v-switch label="Отображать на IOS" v-model="isVisibleOnIos" hide-details color="var(--app-green-1)"></v-switch>
      </div>
    </div>

    <div v-if="!newImage" class="container-block">
      <div class="container-block-title">Фон баннера</div>

      <v-file-input accept="image/*" outlined :rules="[
        (value) =>
          (value && value.size < 104857600) ||
          'Размер изображения не больше 100 мб',
      ]" hint="Максимальный размер изображения 100 мб" persistent-hint v-model="newImage" @change="previewImage"
        label="Прикрепить изображение"></v-file-input>
      <div class="container-block-gallery-button">
        Выбрать изображение из галереи
      </div>
    </div>

    <div v-if="newImage" class="container-block" style="width: 100%">
      <div class="container-block-title">Кадрировать изображение</div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Формат</th>
              <th class="text-left">Место отображенния</th>
              <th class="text-left">Для смартфонов</th>
              <th class="text-left">Для планшетов</th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr style="height: 60px">
              <td class="text-left">Новости и события</td>
              <td class="text-left">Выбран режим «Новости и события»</td>
              <td class="text-left">
                <v-btn v-if="!finishImageMobileAdd" @click="openMobileImg(true)" class="button-accept"
                  style="width: auto !important">
                  Кадрировать
                </v-btn>

                <div v-else class="d-flex">
                  <img @click="openMobileImg(true)" class="table-img" :src="finishImageMobileAdd" />
                  <v-btn outlined @click="openMobileImg(true)" color="var(--app-dark-blue-1) "
                    class="button-accept-outlined" style="width: auto !important; margin-left: 10px">
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn v-if="!finishImageTabletAdd" @click="openTabletImg(true)" class="button-accept"
                  style="width: auto !important">
                  Кадрировать
                </v-btn>
                <div v-else class="d-flex">
                  <img @click="openTabletImg(true)" class="table-img" :src="finishImageTabletAdd" />
                  <v-btn outlined @click="openTabletImg(true)" color="var(--app-dark-blue-1) "
                    class="button-accept-outlined" style="width: auto !important; margin-left: 10px">
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn icon @click="deleteImage">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
            <tr style="height: 60px">
              <td class="text-left">Только события</td>
              <td class="text-left">Выбран режим «Только события</td>
              <td class="text-left">
                <v-btn v-if="!finishImageMobile" @click="openMobileImg(false)" class="button-accept"
                  style="width: auto !important">
                  Кадрировать
                </v-btn>

                <div v-else class="d-flex">
                  <img @click="openMobileImg(false)" class="table-img" :src="finishImageMobile" />
                  <v-btn outlined @click="openMobileImg(false)" color="var(--app-dark-blue-1) "
                    class="button-accept-outlined" style="width: auto !important; margin-left: 10px">
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn v-if="!finishImageTablet" @click="openTabletImg(false)" class="button-accept"
                  style="width: auto !important">
                  Кадрировать
                </v-btn>
                <div v-else class="d-flex">
                  <img @click="openTabletImg(false)" class="table-img" :src="finishImageTablet" />
                  <v-btn outlined @click="openTabletImg(false)" color="var(--app-dark-blue-1) "
                    class="button-accept-outlined" style="width: auto !important; margin-left: 10px">
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn icon @click="deleteImage">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
        Откадрируйте изображения для всех типов устройств
      </v-alert>
      <v-divider></v-divider>

      <v-dialog width="800px" height="auto" persistent v-if="imgSrc" v-model="dialogMobile">
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogMobile = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">
                Отображение на мобильном устройстве
              </div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper ref="cropperMobail" :src="imgSrc" style="width: 450px; height: 450px" :stencil-props="{
                  handlers: {},
                  movable: false,
                  scalable: true,
                }" :stencil-size="{
  width: 343,
  height: 110,
}" image-restriction="stencil" @change="onChangeMobile" />
              </div>

              <div style="width: 100%" class="d-flex justify-center" v-if="resultImageMobile">
                <img width="343px" height="110px" style="margin-left: 30px" :src="resultImageMobile" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeMobileImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog width="800px" height="auto" persistent v-if="imgSrcAdd" v-model="dialogMobileAdd">
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogMobileAdd = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">
                Отображение на мобильном устройстве
              </div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrcAdd" class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper ref="cropperMobailMini" :src="imgSrcAdd" style="width: 450px; height: 450px" :stencil-props="{
                  handlers: {},
                  movable: false,
                  scalable: true,
                }" :stencil-size="{
  width: 164,
  height: 208,
}" image-restriction="stencil" @change="onChangeMobileMini" />
              </div>

              <div style="width: 100%" class="d-flex justify-center" v-if="resultImageMobileAdd">
                <img width="164px" height="208px" :src="resultImageMobileAdd" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeMobileImgMini()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog width="800px" height="auto" persistent v-if="imgSrc" v-model="dialogTablet">
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogTablet = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">Отображение на планшете</div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="">
              <div style="width: 100%; height: 200px">
                <cropper ref="cropperTablet" :src="imgSrc" style="width: 100%; height: 300px" :stencil-props="{
                  handlers: {},
                  movable: false,
                  scalable: true,
                }" :stencil-size="{
  width: 658,
  height: 300,
}" image-restriction="stencil" @change="onChangeTablet" />
              </div>

              <div class="dialog-tablet-img" v-if="resultImageTablet">
                <img width="658px" height="300px" :src="resultImageTablet" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeTabletImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog width="800px" height="auto" persistent v-if="imgSrcAdd" v-model="dialogTabletAdd">
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogTabletAdd = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">Отображение на планшете</div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrcAdd" class="">
              <div style="width: 100%; height: 200px">
                <cropper ref="cropperTabletMini" :src="imgSrcAdd" style="width: 100%; height: 300px" :stencil-props="{
                  handlers: {},
                  movable: false,
                  scalable: true,
                }" :stencil-size="{
  width: 658,
  height: 300,
}" image-restriction="stencil" @change="onChangeTabletMini" />
              </div>

              <div class="dialog-tablet-img" v-if="resultImageTabletAdd">
                <img width="658px" height="300px" :src="resultImageTabletAdd" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeTabletImgMini()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-alert color="var(--app-red-1)" type="error" v-model="errImagesMain">
      Прикрепите изображение
    </v-alert>

    <div class="container-block-footer-buttons">
      <div>
        <v-btn @click="saveEvent" :loading="sendForm" style="width: auto !important" class="button-accept">
          Сохранить
        </v-btn>
      </div>
      <div></div>
    </div>
  </div>
</template>
<script>

import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  components: {
    Cropper,
  },
  data: () => ({
    errImages: false,
    errImagesMain: false,

    dialogMobile: false,

    dialogMobileAdd: false,
    dialogTablet: false,
    dialogTabletAdd: false,
    isVisibleInNewAppVersion: false,
    isVisibleOnAndroid: false,
    isVisibleOnIos: false,
    events: [],

    rules: [(value) => !!value || "Обязательно к заполнению"],

    newImage: null,
    newsOrEventId: "",
    imgSrc: "",
    imgSrcAdd: "",

    resultImageMobile: "",
    resultImageTablet: "",

    finishImageMobile: "",
    finishImageTablet: "",

    resultImageMobileAdd: "",
    resultImageTabletAdd: "",

    finishImageMobileAdd: "",
    finishImageTabletAdd: "",

    smartphoneMainImage: null,
    tabletMainImage: null,

    smartphoneAddImage: null,
    tabletAddImage: null,

    formData: new FormData(),
    sendForm: false,
  }),

  methods: {
    getEvents() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/event/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.events = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    deleteImage() {
      this.newImage = null;
      this.imgSrc = "";
      this.resultImageMobile = "";
      this.resultImageTablet = "";
      this.finishImageMobile = "";
      this.finishImageTablet = "";
      this.smartphoneMainImage = null;
      this.tabletMainImage = null;
      this.imgSrcAdd = "";
      this.resultImageMobileAdd = "";
      this.resultImageTabletAdd = "";
      this.finishImageMobileAdd = "";
      this.finishImageTabletAdd = "";
      this.smartphoneAddImage = null;
      this.tabletAddImage = null;
    },

    openMobileImg(mini) {
      if (mini) {
        this.dialogMobileAdd = true;
        setTimeout(() => {
          this.$refs.cropperMobailMini.refresh();
        }, 500);
      } else {
        this.dialogMobile = true;
        setTimeout(() => {
          this.$refs.cropperMobail.refresh();
        }, 500);
      }

      this.errImages = false;
    },
    openTabletImg(mini) {
      if (mini) {
        this.dialogTabletAdd = true;
        setTimeout(() => {
          this.$refs.cropperTabletMini.refresh();
        }, 500);
      } else {
        this.dialogTablet = true;
        setTimeout(() => {
          this.$refs.cropperTablet.refresh();
        }, 500);
      }

      this.errImages = false;
    },
    closeTabletImg() {
      this.finishImageTablet = this.resultImageTablet;
      this.dialogTablet = false;
      const { canvas } = this.$refs.cropperTablet.getResult();

      canvas.toBlob(
        (blob) => {
          this.formData.append("tabletImage", blob);
        },
        "image/webp",
        0.95
      );
      this.tabletMainImage = true;
    },
    closeTabletImgMini() {
      this.finishImageTabletAdd = this.resultImageTabletAdd;
      this.dialogTabletAdd = false;
      const { canvas } = this.$refs.cropperTabletMini.getResult();

      canvas.toBlob(
        (blob) => {
          this.formData.append("additionalTabletImage", blob);
        },
        "image/webp",
        0.95
      );
      this.tabletAddImage = true;
    },
    closeMobileImg() {
      this.finishImageMobile = this.resultImageMobile;
      this.dialogMobile = false;
      const { canvas } = this.$refs.cropperMobail.getResult();

      canvas.toBlob(
        (blob) => {
          this.formData.append("smartphoneImage", blob);
        },
        "image/webp",
        0.95
      );
      this.smartphoneMainImage = true;
    },
    closeMobileImgMini() {
      this.finishImageMobileAdd = this.resultImageMobileAdd;
      this.dialogMobileAdd = false;
      const { canvas } = this.$refs.cropperMobailMini.getResult();

      canvas.toBlob(
        (blob) => {
          this.formData.append("additionalSmartphoneImage", blob);
        },
        "image/webp",
        0.95
      );
      this.smartphoneAddImage = true;
    },
    back() {
      this.$router.push({ name: "Banners", params: { selectedTicker: 2 } });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    previewImage() {
      if (this.newImage) {
        this.imgSrc = URL.createObjectURL(this.newImage);
        this.imgSrcAdd = URL.createObjectURL(this.newImage);
      } else {
        this.imgSrc = "";
        this.imgSrcAdd = "";
      }
    },

    defaultSize({ imageSize }) {
      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width),
      };
    },

    onChangeMobile({ canvas }) {
      this.resultImageMobile = canvas.toDataURL();
    },
    onChangeMobileMini({ canvas }) {
      this.resultImageMobileAdd = canvas.toDataURL();
    },
    onChangeTablet({ canvas }) {
      this.resultImageTablet = canvas.toDataURL();
    },
    onChangeTabletMini({ canvas }) {
      this.resultImageTabletAdd = canvas.toDataURL();
    },

    saveEvent() {
      if (this.$refs.formFirst.validate()) {
        if (this.newImage) {
          if (
            this.smartphoneMainImage &&
            this.tabletMainImage &&
            this.smartphoneAddImage &&
            this.tabletAddImage
          ) {
            this.errImages = false;
            this.sendForm = true;

            this.formData.append("type", "events");
            this.formData.append("status", "active");
            this.formData.append("isVisibleInNewAppVersion", !this.isVisibleInNewAppVersion);
            this.formData.append("isVisibleOnAndroid", this.isVisibleOnAndroid);
            this.formData.append("isVisibleOnIos", this.isVisibleOnIos);
            this.formData.append(
              "transition",
              JSON.stringify({
                path: this.newsOrEventId,
                transitionType: "deeplink",
              })
            );
            this.formData.append("originalImage", this.newImage || null);

            this.$axios
              .post(
                this.$store.getters.apiAdminPanelV2 + "/banner",
                this.formData,
                {
                  headers: {
                    authorization: this.$store.getters.adminPanelHeaderAuth,
                  },
                }
              )
              .then(() => {
                this.sendForm = false;
                this.$router.push({
                  name: "Banners",
                  params: { selectedTicker: 2 },
                });
              })
              .catch((err) => {
                this.sendForm = false;
                this.$store.commit("errorSet", true);
                this.$store.commit("errorTextSet", err);
              });
          } else {
            this.errImages = true;
          }
        } else {
          this.errImagesMain = true;
        }
      }
    },
  },
  created() {
    this.getEvents();
  },

  watch: {
    newImage() {
      if (this.newImage) {
        this.errImagesMain = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.trumbowyg-title-box {
  border: 1px solid rgb(224, 224, 224);
  border-radius: 4px;
  padding: 2px;
}

.trumbowyg-title-box-error {
  border: 2px solid red !important;
}

.trumbowyg-title-box-text {
  font-size: 16px;
  padding-left: 10px;
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  height: 50px;
}

.switch-label {
  font-size: 16px;
  color: #0000009a;
  margin-bottom: 2px;
}

.container-main {
  box-sizing: border-box;

  padding: 40px !important;

  .container-main-header-button {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .container-block {
    width: 50%;
    margin-bottom: 20px;

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
    }

    .container-block-gallery-button {
      text-decoration: underline;
      color: #1064dd;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
      padding-bottom: 20px;
    }

    .table-img {
      // width: 62px;
      height: 38px;
      object-fit: contain;
    }

    .container-main-checkbox {
      border: 1px solid rgba(0, 0, 0, 0.42);
      border-radius: 4px;
      padding-top: 20px;
      padding-left: 12px;
      margin-top: 0px !important;
    }
  }

  .container-block-footer-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 60px;
  }
}

.dialog-tablet-img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  img {
    width: 658;
    height: 192;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active до версии 2.1.8 */
  {
  opacity: 0;
}
</style>